import 'ant-design-vue/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './global.scss' // app & third-party component styles

import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import NProgress from 'vue-nprogress'
import BootstrapVue from 'bootstrap-vue'
import VueCurrencyFilter from 'vue-currency-filter'
import VueClipboard from 'vue-clipboard2'

import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './localization'
import Antd from './antd'
import IdleVue from 'idle-vue'
import VueMeta from 'vue-meta'

import MomentPlugin from '@/plugins/moment'
import './registerServiceWorker'

const idleTime = process.env.VUE_APP_IDLE_TIME ?? 10
Vue.use(VueClipboard)
Vue.use(VueCurrencyFilter, [
  {
    symbol: 'Rp',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
  },
  {
    // symbol: 'Rp',
    name: 'currency_2',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
  },
])
Vue.use(MomentPlugin)
Vue.use(Antd)
Vue.use(BootstrapVue)
Vue.use(VueMeta)

Vue.use(NProgress)
Vue.use(VuePageTitle, {
  router,
})

Vue.use(IdleVue, {
  store,
  idleTime: idleTime * (60 * 1000),
  startAtIdle: false,
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  i18n,
  render: h => h(App),
}).$mount('#app')
